module.exports = __webpack_public_path__ + "SCGumKids.woff2?65795573a81d52c4dd87141df9d4c349";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SCGumKids.woff2
// module id = 6
// module chunks = 0